import React, { useMemo } from 'react';
import { Flex, Text, Box, Paragraph } from '@zillow/constellation';
import { useLastValidHomeSaleProceedsCalculator, FieldConfig } from './HomeSaleProceedsCalculator.utils.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';

var HomeSaleProceedsContent = function HomeSaleProceedsContent() {
  var lastValidHomeSaleProceedsCalculator = useLastValidHomeSaleProceedsCalculator();
  var _lastValidHomeSalePro = lastValidHomeSaleProceedsCalculator.calculations,
    estimatedSellingCostResult = _lastValidHomeSalePro.estimatedSellingCostResult,
    estimatedNetProceeds = _lastValidHomeSalePro.estimatedNetProceeds,
    estimatedSellingCostPercentage = _lastValidHomeSalePro.estimatedSellingCostPercentage;
  var _lastValidHomeSalePro2 = lastValidHomeSaleProceedsCalculator.fields,
    desiredSellingPrice = _lastValidHomeSalePro2.desiredSellingPrice,
    remainingMortgageOwed = _lastValidHomeSalePro2.remainingMortgageOwed;
  // Dynamically add percentage value to "Est. selling costs"
  var OUTPUTS = useMemo(function () {
    return [{
      label: 'Desired selling price',
      accessor: FieldConfig.desiredSellingPrice.name
    }, {
      label: 'Remaining mortgage owed',
      accessor: FieldConfig.remainingMortgageOwed.name
    }, {
      label: "Est. selling costs (" + estimatedSellingCostPercentage.toFixed(2) + "%)",
      accessor: FieldConfig.estimatedSellingCost.name
    }];
  }, [estimatedSellingCostPercentage]);
  return /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    "aria-live": "polite",
    "aria-atomic": "true",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "h2",
    fontWeight: "normal"
  }, "Estimated net proceeds"), /*#__PURE__*/React.createElement(Text, {
    style: {
      display: 'block'
    },
    fontType: "h2",
    fontColor: "green500",
    margin: "md"
  }, "$", commaSeparateNumber(estimatedNetProceeds)), OUTPUTS.map(function (_ref, index) {
    var label = _ref.label,
      accessor = _ref.accessor;
    return /*#__PURE__*/React.createElement(Box, {
      as: Flex,
      key: accessor,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "sm",
      marginBottom: "sm",
      sx: {
        flexDirection: 'row',
        borderBottom: index !== OUTPUTS.length - 1 ? '1px solid $colors.gray300' : undefined,
        width: '80%'
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "body"
    }, label), accessor === FieldConfig.estimatedSellingCost.name ? /*#__PURE__*/React.createElement(Text, {
      fontType: "bodyHeading"
    }, "$", commaSeparateNumber(estimatedSellingCostResult)) : accessor === FieldConfig.remainingMortgageOwed.name ? /*#__PURE__*/React.createElement(Text, {
      fontType: "bodyHeading"
    }, "$", commaSeparateNumber(remainingMortgageOwed)) : /*#__PURE__*/React.createElement(Text, {
      fontType: "bodyHeading"
    }, "$", commaSeparateNumber(desiredSellingPrice)));
  }));
};
var HomeSaleProceedsContent$1 = HomeSaleProceedsContent;

export { HomeSaleProceedsContent$1 as default };
